"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "38", height: "38", viewBox: "0 0 38 38", className: "Icon toolbar-transparent-on", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement(
            "g",
            { transform: "translate(1 1)", fill: "none", fillRule: "evenodd" },
            _react2.default.createElement("path", { d: "M.875 1.25L4 0v4H0l.875-2.75zM8 0h4v4H8V0zm8 0h4v4h-4V0zm8 0h4v4h-4V0zm8 0l2.75 1L36 4h-4V0zM4 4h4v4H4V4zm8 0h4v4h-4V4zm8 0h4v4h-4V4zm8 0h4v4h-4V4zM0 8h4v4H0V8zm8 0h4v4H8V8zm8 0h4v4h-4V8zm8 0h4v4h-4V8zm8 0h4v4h-4V8zM4 12h4v4H4v-4zm8 0h4v4h-4v-4zm8 0h4v4h-4v-4zm8 0h4v4h-4v-4zM0 16h4v4H0v-4zm8 0h4v4H8v-4zm8 0h4v4h-4v-4zm8 0h4v4h-4v-4zm8 0h4v4h-4v-4zM4 20h4v4H4v-4zm8 0h4v4h-4v-4zm8 0h4v4h-4v-4zm8 0h4v4h-4v-4zM0 24h4v4H0v-4zm8 0h4v4H8v-4zm8 0h4v4h-4v-4zm8 0h4v4h-4v-4zm8 0h4v4h-4v-4zM4 28h4v4H4v-4zm8 0h4v4h-4v-4zm8 0h4v4h-4v-4zm8 0h4v4h-4v-4zM0 32h4v4l-2.875-.875L0 32zm8 0h4v4H8v-4zm8 0h4v4h-4v-4zm8 0h4v4h-4v-4zm8 0h4l-.875 2.875L32 36v-4z", fill: "#D9D9D9" }),
            _react2.default.createElement("rect", { stroke: "#000", width: "36", height: "36", rx: "3", strokeWidth: "2" }),
            _react2.default.createElement("path", { d: "M17.702 8c2.156 0 3.913 1.745 3.913 3.886 0 .296-.064.603-.163.918.272-.191.544-.34.83-.432a3.948 3.948 0 0 1 1.548-.175 3.91 3.91 0 0 1 3.383 2.672c.667 2.036-.463 4.223-2.513 4.885-.287.092-.601.13-.938.134.268.198.503.407.68.648a3.87 3.87 0 0 1-.856 5.425c-1.745 1.259-4.209.882-5.476-.85a3.036 3.036 0 0 1-.408-.837 3.036 3.036 0 0 1-.407.837c-1.267 1.732-3.732 2.109-5.476.85a3.87 3.87 0 0 1-.856-5.425c.176-.24.412-.45.68-.648a3.194 3.194 0 0 1-.938-.134c-2.05-.662-3.18-2.849-2.513-4.885a3.91 3.91 0 0 1 3.383-2.672 3.948 3.948 0 0 1 1.549.175c.285.092.557.24.828.432a3.105 3.105 0 0 1-.163-.918C13.79 9.746 15.547 8 17.702 8zm0 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4z", fill: "#424242", fillRule: "nonzero" })
        )
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/large/jsx/toolbar-transparent-on.js
// module id = 1852
// module chunks = 0